import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux'; // Connecting to Redux
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import { Button, Input } from 'antd';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(AudioTest)'
interface AudioTestProps extends RouteComponentProps<{}> {
}

interface AudioTestState {
}

class AudioTest extends React.Component<AudioTestProps, AudioTestState> {
    backgroundMusic: HTMLAudioElement;
    sound: HTMLAudioElement;
    count: number = 0;

    constructor(props: AudioTestProps) {
        super(props);
        bindAllOfThis(this, AudioTest.prototype);

        this.backgroundMusic = new Audio(require('src/assets/online-assets/sounds/bird-chirping.mp3'));
        this.backgroundMusic.pause();
        this.sound = new Audio(require('src/assets/online-assets/sounds/keyboard-press-long.mp3'));
        this.sound.pause();

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    componentWillUnmount() {
        this.backgroundMusic.pause();
    }

    playSoundAlpha(a: React.MouseEvent<HTMLElement>) {
        this.backgroundMusic.play();
    }

    textChange() {
        this.sound.play().then(() => {
            this.randoSound();
        });
    }

    randoSound() {
        const modCount: number = 2;
        if (this.count % modCount === 0) {
            this.sound = new Audio(require('src/assets/online-assets/sounds/keyboard-press-long.mp3'));
        } else if (this.count % modCount === 1) {
            this.sound = new Audio(require('src/assets/online-assets/sounds/keyboard-press-short.mp3'));
        }

        this.sound.pause();
    }

    render() {
        return (<div>
            <span>Hey do you hear that? Thats music! Or a bird, maybe a duck?</span>
            <div>
                <Button type="primary" onClick={x => this.playSoundAlpha(x)}> Click!</Button>
                <Input placeholder="Hear cool typing sounds!" onChange={this.textChange} />
            </div>
        </div>);
    }
}

export default AudioTest;



// WEBPACK FOOTER //
// ./src/pages/admin/AudioTest.tsx